import { enhanceAllSQLModulesWithQuizzes } from './enhancedModuleEnhancer';
import { SQL_FUNDAMENTALS_MODULES } from './modules/fundamentals';
import { SQL_INTERMEDIATE_MODULES } from './modules/intermediate';
import { SQL_ADVANCED_MODULES } from './modules/advanced';
import { SQL_FUNDAMENTALS_EXPANDED_MODULES } from './modules/fundamentalsExpanded';
import { SQL_INTERMEDIATE_EXPANDED_MODULES } from './modules/intermediateExpanded';
import { SQL_ADVANCED_EXPANDED_MODULES } from './modules/advancedExpanded';
import { SQLCourse } from './types';
import { SQL_PHASE2_COURSE } from './phase2Course';
import { SQL_PHASE3_COURSE } from './phase3Course';
import { SQL_PHASE4_COURSE } from './phase4Course';
import { SQL_PHASE5_COURSE } from './phase5Course';
import { SQL_PHASE6_COURSE } from './phase6Course';

// Combine original and expanded modules
const allFundamentalsModules = [...SQL_FUNDAMENTALS_MODULES, ...SQL_FUNDAMENTALS_EXPANDED_MODULES];
const allIntermediateModules = [...SQL_INTERMEDIATE_MODULES, ...SQL_INTERMEDIATE_EXPANDED_MODULES];
const allAdvancedModules = [...SQL_ADVANCED_MODULES, ...SQL_ADVANCED_EXPANDED_MODULES];

// Enhance all modules with comprehensive quiz content
const enhancedFundamentalsModules = enhanceAllSQLModulesWithQuizzes(allFundamentalsModules);
const enhancedIntermediateModules = enhanceAllSQLModulesWithQuizzes(allIntermediateModules);
const enhancedAdvancedModules = enhanceAllSQLModulesWithQuizzes(allAdvancedModules);

export const SQL_COURSES: SQLCourse[] = [
  {
    id: 'sql-fundamentals',
    title: 'SQL Fundamentals',
    description: 'Master the basics of SQL with hands-on practice and comprehensive assessments.',
    level: 'beginner',
    duration: '12 hours',
    estimatedHours: 12,
    modules: enhancedFundamentalsModules,
    requirements: ['Basic computer literacy', 'Understanding of data concepts'],
    tags: ['SQL', 'Database', 'Beginner', 'Fundamentals'],
    image: '/images/sql-fundamentals.jpg'
  },
  {
    id: 'sql-intermediate',
    title: 'Intermediate SQL',
    description: 'Advanced querying techniques, joins, and database optimization.',
    level: 'intermediate',
    duration: '18 hours',
    estimatedHours: 18,
    modules: enhancedIntermediateModules,
    requirements: ['SQL Fundamentals', 'Basic database concepts'],
    tags: ['SQL', 'Database', 'Intermediate', 'Joins', 'Optimization'],
    image: '/images/sql-intermediate.jpg'
  },
  {
    id: 'sql-advanced',
    title: 'Advanced SQL',
    description: 'Complex queries, stored procedures, performance tuning, and database administration.',
    level: 'advanced',
    duration: '24 hours',
    estimatedHours: 24,
    modules: enhancedAdvancedModules,
    requirements: ['Intermediate SQL', 'Database design principles'],
    tags: ['SQL', 'Database', 'Advanced', 'Performance', 'Administration'],
    image: '/images/sql-advanced.jpg'
  }
];

// Re-export individual modules for backward compatibility
export { SQL_FUNDAMENTALS_MODULES, SQL_INTERMEDIATE_MODULES, SQL_ADVANCED_MODULES };
export { SQL_FUNDAMENTALS_EXPANDED_MODULES, SQL_INTERMEDIATE_EXPANDED_MODULES, SQL_ADVANCED_EXPANDED_MODULES };

// Export Phase 2-6 courses
export { SQL_PHASE2_COURSE } from './phase2Course';
export { SQL_PHASE3_COURSE } from './phase3Course';
export { SQL_PHASE4_COURSE } from './phase4Course';
export { SQL_PHASE5_COURSE } from './phase5Course';
export { SQL_PHASE6_COURSE } from './phase6Course';

// Create combined array for Phase 2-6
export const SQL_ADVANCED_PHASE_COURSES = [
  SQL_PHASE2_COURSE,
  SQL_PHASE3_COURSE,
  SQL_PHASE4_COURSE,
  SQL_PHASE5_COURSE,
  SQL_PHASE6_COURSE
];

export * from './types';
